export const previewCardImageHeight = 150;
export const productInformationImageHeight = 250;
export const previewCardMinHeight = 324;
